// Mutations
export const SET_PAYMENT = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.payment.data = payload
    state.payment.lastUpdate = new Date()
  }
}
export const ADD_PAYMENT = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.payment.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.payment.data.push(data)
      }
    })
  }
}
export const SET_PAYMENT_LOADING = (state, payload) => {
  state.payment.loading = payload
}

export const SET_STOCK_OPTION = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.stockOption.data = payload
    state.stockOption.lastUpdate = new Date()
  }
}
export const ADD_STOCK_OPTION = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.stockOption.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.stockOption.data.push(data)
      }
    })
  }
}
export const SET_STOCK_OPTION_LOADING = (state, payload) => {
  state.stockOption.loading = payload
}
export const SET_KIT_PARTNERS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.kitPartners.data = payload
    state.kitPartners.lastUpdate = new Date()
  }
}
export const ADD_KIT_PARTNERS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.kitPartners.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.kitPartners.data.push(data)
      }
    })
  }
}
export const SET_KIT_PARTNERS_LOADING = (state, payload) => {
  state.kitPartners.loading = payload
}

export const SET_STATUS_KIT_PARTNERS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.statusKitPartners.data = payload
    state.statusKitPartners.lastUpdate = new Date()
  }
}
export const ADD_STATUS_KIT_PARTNERS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.statusKitPartners.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.statusKitPartners.data.push(data)
      }
    })
  }
}
export const SET_STATUS_KIT_PARTNERS_LOADING = (state, payload) => {
  state.statusKitPartners.loading = payload
}

export const SET_STATUS_KIT_CLIENTS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.statusKitClients.data = payload
    state.statusKitClients.lastUpdate = new Date()
  }
}
export const ADD_STATUS_KIT_CLIENTS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.statusKitClients.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.statusKitClients.data.push(data)
      }
    })
  }
}
export const SET_STATUS_KIT_CLIENTS_LOADING = (state, payload) => {
  state.statusKitClients.loading = payload
}

export const SET_DOCUMENTS_KIT_PARTNERS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.documentsKitPartners.data = payload
    state.documentsKitPartners.lastUpdate = new Date()
  }
}
export const ADD_DOCUMENTS_KIT_PARTNERS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.documentsKitPartners.data.find(
        (item) => item.id === data.id
      )
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.documentsKitPartners.data.push(data)
      }
    })
  }
}
export const SET_DOCUMENTS_KIT_PARTNERS_LOADING = (state, payload) => {
  state.documentsKitPartners.loading = payload
}

export const SET_TIPO_KIT_PARTNERS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.tipoKitPartners.data = payload
    state.tipoKitPartners.lastUpdate = new Date()
  }
}
export const ADD_TIPO_KIT_PARTNERS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.tipoKitPartners.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.tipoKitPartners.data.push(data)
      }
    })
  }
}
export const SET_TIPO_KIT_PARTNERS_LOADING = (state, payload) => {
  state.tipoKitPartners.loading = payload
}

export const SET_PROFESSIONAL_KIT_PARTNERS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.professionalKitPartners.data = payload
    state.professionalKitPartners.lastUpdate = new Date()
  }
}
export const ADD_PROFESSIONAL_KIT_PARTNERS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.professionalKitPartners.data.find(
        (item) => item.id === data.id
      )
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.professionalKitPartners.data.push(data)
      }
    })
  }
}
export const SET_PROFESSIONAL_KIT_PARTNERS_LOADING = (state, payload) => {
  state.professionalKitPartners.loading = payload
}

export const SET_CLIENT_KIT_PARTNERS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.clientKitPartners.data = payload
    state.clientKitPartners.lastUpdate = new Date()
  }
}
export const ADD_CLIENT_KIT_PARTNERS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.clientKitPartners.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.clientKitPartners.data.push(data)
      }
    })
  }
}
export const SET_CLIENT_KIT_PARTNERS_LOADING = (state, payload) => {
  state.clientKitPartners.loading = payload
}

export const SET_CONJUNTO_KIT_PARTNERS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.conjuntoKitPartners.data = payload
    state.conjuntoKitPartners.lastUpdate = new Date()
  }
}
export const ADD_CONJUNTO_KIT_PARTNERS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.conjuntoKitPartners.data.find(
        (item) => item.id === data.id
      )
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.conjuntoKitPartners.data.push(data)
      }
    })
  }
}
export const SET_OPCOES_KIT_PARTNERS_LOADING = (state, payload) => {
  state.opcoesKitPartners.loading = payload
}

export const SET_OPCOES_KIT_PARTNERS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.opcoesKitPartners.data = payload
    state.opcoesKitPartners.lastUpdate = new Date()
  }
}
export const ADD_OPCOES_KIT_PARTNERS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.opcoesKitPartners.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.opcoesKitPartners.data.push(data)
      }
    })
  }
}
export const SET_CONJUNTO_KIT_PARTNERS_LOADING = (state, payload) => {
  state.conjuntoKitPartners.loading = payload
}

export const SET_PJ_KIT_PARTNERS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.pjKitPartners.data = payload
    state.pjKitPartners.lastUpdate = new Date()
  }
}
export const ADD_PJ_KIT_PARTNERS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.pjKitPartners.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.pjKitPartners.data.push(data)
      }
    })
  }
}
export const SET_PJ_KIT_PARTNERS_LOADING = (state, payload) => {
  state.pjKitPartners.loading = payload
}

export const SET_VINCULO_KIT_PARTNERS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.vinculoKitPartners.data = payload
    state.vinculoKitPartners.lastUpdate = new Date()
  }
}
export const ADD_VINCULO_KIT_PARTNERS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.vinculoKitPartners.data.find(
        (item) => item.id === data.id
      )
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.vinculoKitPartners.data.push(data)
      }
    })
  }
}
export const SET_VINCULO_KIT_PARTNERS_LOADING = (state, payload) => {
  state.vinculoKitPartners.loading = payload
}
